var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F59B00",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.6c-2.56 0-4.96.64-7.2 1.92-2.24 1.28-4 3.04-5.28 5.28A14.277 14.277 0 0 0 1.6 16c0 2.56.64 4.96 1.92 7.2 1.28 2.24 3.04 4 5.28 5.28 2.24 1.28 4.64 1.92 7.2 1.92 2.56 0 4.96-.64 7.2-1.92 2.24-1.28 4-3.04 5.28-5.28 1.28-2.24 1.92-4.64 1.92-7.2 0-2.56-.64-4.96-1.92-7.2-1.28-2.24-3.04-4-5.28-5.28A14.277 14.277 0 0 0 16 1.6zM16 0c2.88 0 5.547.72 8 2.16A16.135 16.135 0 0 1 29.84 8c1.44 2.453 2.16 5.12 2.16 8s-.72 5.547-2.16 8A16.135 16.135 0 0 1 24 29.84C21.547 31.28 18.88 32 16 32s-5.547-.72-8-2.16A16.135 16.135 0 0 1 2.16 24C.72 21.547 0 18.88 0 16s.72-5.547 2.16-8A16.135 16.135 0 0 1 8 2.16C10.453.72 13.12 0 16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.188 11.432l-3.26-3.26C19.87 8.057 19.785 8 19.67 8h-.086c-.114 0-.2.057-.257.172L8.086 19.327A.762.762 0 0 0 8 19.67v3.261c0 .114.043.214.129.3a.412.412 0 0 0 .3.129h3.26a.412.412 0 0 0 .301-.129.412.412 0 0 0 0-.6.412.412 0 0 0-.3-.13H8.858v-2.66l7.466-7.465 2.66 2.66-5.835 5.75c-.115.114-.172.229-.172.343 0 .114.043.214.129.3a.412.412 0 0 0 .3.129c.114 0 .229-.057.343-.172l9.44-9.353a.762.762 0 0 0 .085-.343c0-.115-.028-.2-.086-.258zm-3.604 2.918l-2.66-2.574 2.66-2.746 2.66 2.66-2.66 2.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressActiveIcon);
export default __webpack_public_path__ + "static/media/in-progress-active_icon.7f7a77fbd29acc025428610cdfa38faa.svg";
export { ForwardRef as ReactComponent };